import {
  DXRG,
  useReactDataGrid,
} from '@lmt/unicorn-shared/app/common/devexpress/ReactGrid/dx-react-grid';
import { secondsToTimeString } from '@lmt/unicorn-shared/app/helpers/date-helper';
import {
  FullHeightGridRoot,
  GetStyledRow,
  HideNullTitlesHeaderContent,
  HoverableTable,
  StickyHeaderRow,
} from '@lmt/unicorn-shared/app/helpers/devextreme-helper';
import { Paper } from '@mui/material';
import { SubtenantDto } from '@lmt/shared-types';
import { ScrollToTop } from '@lmt/unicorn-shared/app/components/common/table/helper';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import React, { FC, useEffect, useMemo, useRef } from 'react';
import { useReactDataGridLocalization } from '@lmt/unicorn-shared/app/common/devexpress/ReactGrid/dx-react-grid-localization';

type Props = {
  noResults: boolean;
  data: SubtenantDto[];
  onEdit: (id: number) => void;
};

const TableKeys: { [dictionary: string]: string } = {
  name: 'name',
  workingTimeStart: 'working_time_start',
  workingTimeEnd: 'working_time_end',
};

export const SubtenantsTable: FC<Props> = React.memo(function SubtenantsTable(
  props,
) {
  const i18n = useScopedTranslation('subtenants.list');
  const tableRef = useRef<HTMLDivElement>(null);

  useReactDataGrid();
  const localizationMessages = useReactDataGridLocalization();

  useEffect(() => {
    if (tableRef.current !== null) {
      ScrollToTop(tableRef.current);
    }
  }, [props.data]);

  const columns = useMemo(
    () => [
      {
        name: TableKeys.name,
        title: i18n.t(`columns.${TableKeys.name}` as any),
        getCellValue: (row: SubtenantDto) => `${row.name} ${row.code}`,
      },
      {
        name: TableKeys.workingTimeStart,
        title: i18n.t(`columns.${TableKeys.workingTimeStart}` as any),
        getCellValue: (row: SubtenantDto) =>
          secondsToTimeString(row.workingTimeStartInSeconds),
      },
      {
        name: TableKeys.workingTimeEnd,
        title: i18n.t(`columns.${TableKeys.workingTimeEnd}` as any),
        getCellValue: (row: SubtenantDto) =>
          secondsToTimeString(row.workingTimeEndInSeconds),
      },
    ],
    [],
  );

  return (
    <Paper style={{ height: '100%', width: '100%' }}>
      <DXRG.Grid
        columns={columns}
        rows={props.data}
        rootComponent={FullHeightGridRoot}
      >
        <DXRG.SortingState columnSortingEnabled={false} />
        <DXRG.IntegratedSorting />
        <DXRG.Table
          messages={localizationMessages}
          tableComponent={HoverableTable}
          rowComponent={GetStyledRow((row) => props.onEdit(row.id))}
        />
        <DXRG.TableHeaderRow
          showSortingControls
          contentComponent={HideNullTitlesHeaderContent}
          rowComponent={StickyHeaderRow}
        />
      </DXRG.Grid>
    </Paper>
  );
});
